import api from '@/api'
import config from '@/config'
import dayjs from 'dayjs'
import Multiselect from 'vue-multiselect'
import CustomerItem from './CustomerItem'
import { mapGetters } from 'vuex'
import FilterCustomer from '@/components/elements/FilterCustomer'
import XLSX from 'xlsx'
import { cloneDeep } from 'lodash'

export default {
  data: function() {
    var headers = []

    if (this.$store.state.selectedBot.theme == 'hafele') {
      headers.push({ text: this.$t('ID'), value: 'emp_id' })
    }

    headers = headers.concat([
      { text: '', sortable: false },
      { text: this.$t('name'), value: 'first_name' },
      { text: this.$t('Channel'), value: 'app' },
      { text: this.$t('gender'), value: 'gender' },
      { text: this.$t('Register Date'), value: 'registertimestamp' },
      { text: this.$t('Last Active Date'), value: 'timestamp' },
      { text: this.$t('Email'), value: 'email' },
      { text: this.$t('phone no.'), value: 'phoneno' },
      { text: this.$t('Status'), value: 'status' },
      { text: this.$t('Locale'), value: 'locale' },
      { text: this.$t('order_quantity'), value: 'event_data', align: 'center' },
      { text: this.$t('total_purchase_amount'), value: 'event_data' },
      { text: this.$t('first_time_purchase'), value: 'event_data' },
      { text: this.$t('latest_purchase'), value: 'event_data' },
      { text: this.$t('Lineid'), value: 'lineid' },
      { text: this.$t('Province'), value: 'province' },
      { text: this.$t('School'), value: 'school' },
      { text: '', sortable: false }
    ])

    return {
      loadingItem: false,
      loadingItemValue: 0,
      customAudienceName: null,
      headers: headers,
      pageNumber: 1,
      pagination: { rowsPerPage: -1, sortBy: '' },
      tag: '',
      singleStatus: '',
      showAdvance: false,
      previousFilterApp: null, // This variable is for saving the previous filter of the application when the user changes the app filter in advanced search but does not press the search button
      users: [],
      limit: 100,
      offset: 0,
      count: 0,
      gendercount: '',
      users_count: [],
      intents: [],
      delayImport: false,
      search: '',
      filter: null,
      loading: true,
      errorFilterTag: [],
      pagetmp: 1,
      errorFilterStatus: [],
      customerfromfb: null,
      total_user: '',
      exportlimit: 5000,
      exportAllLimit: 100000,
      showExport: false,
      exportpagecount: 0,
      loadCount: true,
      hasNext: false,
      hasPrev: false,
      counttype: 'onetime',
      exportType: null,
      createCustomAudienceDialog: false,
      historyCustomAudiencePage: false,
      allUsers: [],
      customAudienceLimit: 1000
    }
  },
  components: {
    CustomerItem,
    Multiselect,
    FilterCustomer
  },
  mounted: async function() {
    this.filter = cloneDeep(this.resetSearch())
    await this.getIntent()

    this.loading = true
    try {
      var { users, isnext, count } = await this.getLoadUsers(this.limit, this.offset)
      this.offset += this.limit
      this.users = this.users.concat(users)
      this.hasNext = isnext
    } catch (error) {
      console.log(error)
    }

    this.loading = false
    this.$store.dispatch('loadStatus')
    await this.loadCountData()
  },
  computed: {
    pagelength() {
      if (this.total_user !== '') {
        return Math.ceil(this.total_user / 100)
      } else {
        return 1
      }
    },
    isBU() {
      return this.$store.state.pageBU.includes(this.selectedBot.pageid)
    },
    filteredHeader() {
      const packages = this.getPackageType()
      if (this.isBU) {
        if (!packages.includes('advanced')) {
          return this.headers.map(v => {
            if (v.value === 'event_data') {
              v.sortable = false
            }
            return v
          })
        }
        return this.headers
      } else if (this.$store.state.niveapage.includes(this.selectedBot.pageid)) {
        return [
          { text: '', sortable: false },
          { text: this.$t('name'), value: 'first_name' },
          { text: this.$t('Channel'), value: 'app' },
          { text: this.$t('gender'), value: 'gender' },
          { text: this.$t('Message Sent'), value: 'usermessages' },
          { text: this.$t('Register Date'), value: 'registertimestamp' },
          { text: this.$t('Last Active Date'), value: 'timestamp' },
          { text: this.$t('Email'), value: 'email' },
          { text: this.$t('phone no.'), value: 'phoneno' },
          { text: this.$t('Status'), value: 'status' },
          // { text: this.$t('Message Sent'), value: 'messagesent' },
          { text: this.$t('Locale'), value: 'locale' },
          { text: '', sortable: false }
        ]
      } else {
        if (packages.includes('advanced')) {
          return this.headers.filter(v => {
            return !['lineid', 'province', 'school'].includes(v.value)
          })
        } else {
          return this.headers
            .filter(v => {
              return !['lineid', 'province', 'school'].includes(v.value)
            })
            .map(v => {
              if (v.value === 'event_data') {
                v.sortable = false
              }
              return v
            })
        }
      }
    },
    hasAdvanced() {
      const packages = this.getPackageType()
      return packages.includes('advanced')
      // return false
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      isCoachlab: 'isCoachlab'
    }),
    computedImportDelay() {
      const vm = this
      if (vm.selectedBot.lock_facebook_insert_from_conversation_until_at) {
        const now = dayjs()
        const date = dayjs(vm.selectedBot.lock_facebook_insert_from_conversation_until_at)
        return parseInt(date.diff(now, 'seconds'))
      }
    },
    pageid: function() {
      return this.$store.state.selectedBot.pageid
    },
    filterIntent: function() {
      var vm = this
      vm.intents.sort(function(a, b) {
        var nameA = a.intentname.toUpperCase() // ignore upper and lowercase
        var nameB = b.intentname.toUpperCase() // ignore upper and lowercase
        if (a.intentname[0] == '{' && a.intentname[a.intentname.length - 1] == '}') {
          return 1
        }
        if (b.intentname[0] == '{' && b.intentname[b.intentname.length - 1] == '}') {
          return -1
        }
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }

        // names must be equal
        return 0
      })
      var intents = []
      $.each(vm.intents, function(index, intent) {
        intents.push(intent.intentname)
      })
      return intents
    },
    tags: {
      get() {
        let vm = this
        if (vm.filter && vm.filter.tags && vm.filter.tags !== '') {
          var tags = []
          tags = vm.filter.tags.split(',')
          var result = []
          if (tags) {
            tags.map(function(tag, index) {
              result.push({ text: tag })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function(tag, index) {
            result.push(tag.text)
          })
        }
        vm.filter.tags = result.join(',')
      }
    },
    status: {
      get() {
        let vm = this
        if (vm.filter && vm.filter.status && vm.filter.status !== '') {
          var status = []
          status = vm.filter.status.split(',')
          var result = []
          if (status) {
            status.map(function(s, index) {
              result.push({ text: s })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function(s, index) {
            result.push(s.text)
          })
        }
        vm.filter.status = result.join(',')
      }
    }
  },
  methods: {
    async updateCustomAudience(audience_id, user_ids) {
      var data = {
        pageid: this.selectedBot.pageid,
        audience_id: audience_id,
        body: { user_ids: user_ids }
      }
      var response = await api.updateCustomAudience(data)
      if (response.success) {
        return response
      }
    },
    async createCustomAudience() {
      var vm = this
      vm.loadingItemValue = 0
      try {
        vm.createCustomAudienceDialog = false
        var filter = vm.convertFilter()
        let data = {
          pageid: vm.pageid,
          body: {
            custom_audience_name: 'ZWIZ_' + vm.customAudienceName,
            filter_data: filter
          }
        }
        vm.loadingItem = true
        var response = await api.createCustomAudience2(data)
        if (response.success) {
          let interval = null
          interval = setInterval(async () => {
            let responseCheck = await api.checkCreateCustomAudience(data)
            const result = responseCheck.result

            vm.loadingItemValue = parseInt(
              ((result.total_user_ids_group_completed + result.total_user_ids_group_failed) /
                result.total_user_ids_group) *
                100
            )
            if (
              result.total_user_ids_group_completed + result.total_user_ids_group_failed ===
              result.total_user_ids_group
            ) {
              if (result.error_data) {
                if (interval) clearInterval(interval)
                await vm.$swal.fire({
                  title: vm.$t('error'),
                  text: result.error_data,
                  type: 'error',
                  confirmButtonText: vm.$t('Confirm'),
                  showCancelButton: false,
                  reverseButtons: true
                })
                vm.loadingItem = false
              } else {
                if (interval) clearInterval(interval)
                vm.loadingItem = false
                vm.$swal.fire({
                  title: vm.$t('Successfully'),
                  type: 'success',
                  confirmButtonText: vm.$t('Confirm'),
                  reverseButtons: true
                })
              }
            }
          }, 5000)
        } else {
          if (response.response) {
            vm.$swal.fire({
              title: vm.$t('error'),
              text: `${response.response.data.result.error.message} : ${response.response.data.result.error.error_user_msg}`,
              type: 'error',
              confirmButtonText: vm.$t('Confirm'),
              reverseButtons: true
            })
            vm.loadingItem = false
          }
        }
      } catch (error) {
        vm.loadingItem = false
        vm.createCustomAudienceDialog = false
        if (vm.allUsers.length <= vm.customAudienceLimit) {
          vm.$swal.fire({
            title: vm.$t('error'),
            text: error.message,
            type: 'error',
            confirmButtonText: vm.$t('Confirm'),
            reverseButtons: true
          })
        }
      }
    },
    resetSearch() {
      return {
        fullname: '',
        gender: {
          label: this.$t('All'),
          value: 'all'
        },
        payStatus: null,
        locale: null,
        app: { label: 'Facebook', value: 'facebook' },
        intent: null,
        email: '',
        phoneno: '',
        messagesent: {
          value: null,
          symbol: {
            value: 'g__',
            label: this.$t('Greater than')
          }
        },
        timezone: {
          from: -12,
          to: 14
        },
        activeDate: {
          enable: false,
          start: null,
          end: null
        },
        registerDate: {
          enable: false,
          start: null,
          end: null
        },
        status: '',
        tags: '',
        lineid: '',
        school: '',
        province: '',
        uu_register_status: '',
        specialcondition: '',
        statustype: 'includes',
        filter_event_data_value: {},
        filter_event_data_quantity: {},
        filter_event_data_time: {}
      }
    },
    async loadCountData() {
      this.loadCount = true
      if (this.counttype == 'onetime') {
        try {
          var { users, isnext, count } = await this.getLoadAllUsers()
          this.allUsers = []
          users.map(item => {
            this.allUsers.push(item.id)
          })
          this.total_user = count
        } catch (error) {
          this.total_user = false
          if (
            this.$store.getters.getPackage == 'premium' ||
            this.selectedBot.pagetype == 'enterprise'
          )
            this.counttype = 'recursive'
        }
      } else {
        var { users, isnext, count } = await this.recursiveLoadUser(5000, 0)
        this.allUsers = []
        users.map(item => {
          this.allUsers.push(item.id)
        })
        this.total_user = count
      }
      this.loadCount = false
    },
    async recursiveLoadUser(limit, offset) {
      var { users, isnext, count } = await this.getLoadUsers(limit, offset)
      if (isnext) {
        var next = await this.recursiveLoadUser(limit, offset + limit)

        return {
          users: null,
          isnext: isnext,
          count: parseInt(count) + (next.count ? parseInt(next.count) : 0)
        }
      } else {
        return { users: users, isnext: false, count: count }
      }
    },
    async getLoadAllUsers() {
      let vm = this
      return new Promise((resolve, reject) => {
        var filter = this.convertFilter()
        let data = {
          body: {
            pageid: vm.pageid,
            grouptype: vm.grouptype,
            payment_flag:
              vm.filter.payStatus && vm.filter.payStatus.length ? vm.filter.payStatus : null,
            filter_payment_status:
              vm.filter.payStatus && vm.filter.payStatus.length ? vm.filter.payStatus : null,
            ...filter
          }
        }

        api.post_all_users(data, function(error, response) {
          if (error) {
            reject(error)
          }

          var users = response.data
          // vm.total_user = response.count
          resolve({ users: users, isnext: response.isNext, count: response.count })
        })
      })
    },
    async onChangePage({ currentpage, newpage, onchange }) {
      this.loading = true
      try {
        var offset = (newpage - 1) * this.limit
        var { users, isnext, count } = await this.getLoadUsers(this.limit, offset)
        this.offset = offset + this.limit
        this.users = users
        if (newpage - 1 != 0) this.hasPrev = true
        this.hasNext = isnext
        if (onchange) {
          onchange(newpage)
        }
      } catch (error) {
        if (onchange) {
          onchange(currentpage)
        }
      }
      this.loading = false
    },
    onCountdownEnd() {
      this.$store.commit('REMOVE_DELAY_IMPORT', {
        pageid: this.selectedBot.pageid
      })
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * 100 - 100
        if (vm.pageNumber != 1) {
          vm.offset + 1
        }
        vm.pageloading = true
        this.getMoreCustomers()
      }
    },
    estimateReach: function(data) {
      var vm = this

      vm.loadingEstimate = true
      api.estimateReach({ data }, function(error, response) {
        if (error) {
          console.error(error)

          return
        }
        if (response.data) {
          vm.total_user = response.data.total
        }
      })
    },
    checkTag(obj) {
      this.errorFilterTag = []
      if (obj.tag.text.length > 20) {
        this.errorFilterTag.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorFilterTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    addTags: function(newTags) {
      this.tags = newTags
    },
    checkStatus(obj) {
      this.errorFilterStatus = []
      if (obj.tag.text.length > 20) {
        this.errorFilterStatus.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorFilterStatus.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    addStatus: function(newTags) {
      this.status = newTags
    },
    clearSearch: function() {
      this.filter = cloneDeep(this.resetSearch())
      this.$forceUpdate()

      this.onSearch()
    },
    onSearch: async function() {
      const $filterCustomer = this.$refs.filterCustomer
      let result = false

      if ($filterCustomer) {
        result = await $filterCustomer.$validator.validate()
      } else {
        result = await this.$validator.validate()
      }

      const vm = this

      if (!result) {
        vm.goToErrorInput()
        return false
      }

      vm.offset = 0

      vm.hasPrev = false
      vm.users = []
      vm.loading = true

      this.previousFilterApp = null // Remove this value because the user has already pressed the search button

      try {
        var { users, isnext, count } = await vm.getLoadUsers(vm.limit, vm.offset)
        vm.users = users
        vm.hasNext = isnext
      } catch (error) {}
      vm.loading = false
      await this.loadCountData()
    },
    collectexportcustomersanalytic() {
      var vm = this
      let data = {
        pageid: vm.pageid,
        grouptype: vm.grouptype,
        filter: vm.filter,
        limit: vm.limit,
        offset: vm.offset
      }

      api.putcollectexportcustomersanalytic(data, function(error, response) {
        if (error) {
          console.error(error)

          return
        }
      })
    },
    convertFilter() {
      var filter = cloneDeep(this.filter)
      try {
        if (filter.app) {
          filter.app = filter.app.value
        }
        if (filter.gender) {
          filter.gender = filter.gender.value
        }
        if (filter.activeDate && filter.activeDate.start) {
          filter.timestamp_from = filter.activeDate.start
        }
        if (filter.activeDate && filter.activeDate.end) {
          filter.timestamp_to = filter.activeDate.end
        }
        if (filter.registerDate && filter.registerDate.start) {
          filter.registertimestamp_from = filter.registerDate.start
        }
        if (filter.registerDate && filter.registerDate.end) {
          filter.registertimestamp_to = filter.registerDate.end
        }
        if (filter.locale) {
          try {
            var locale = filter.locale.map(el => {
              return el.value
            })
            filter.locale = locale.join(',')
          } catch (error) {}
        }
        if (filter.status) {
          filter.status = filter.status.join(',')
        }
        if (filter.specialcondition && filter.specialcondition.value) {
          filter.specialcondition = filter.specialcondition.value
        }
      } catch (error) {
        console.error(error)
      }
      return filter
    },
    getLoadUsers: function(limit, offset) {
      let vm = this
      return new Promise((resolve, reject) => {
        var filter = this.convertFilter()
        let data = {
          params: {
            limit: limit,
            offset: offset
          },
          body: {
            pageid: vm.pageid,
            grouptype: vm.grouptype,
            payment_flag:
              vm.filter.payStatus && vm.filter.payStatus.length ? vm.filter.payStatus : null,
            filter_payment_status:
              vm.filter.payStatus && vm.filter.payStatus.length ? vm.filter.payStatus : null,
            select_fields: [
              'id',
              'first_name',
              'last_name',
              'gender',
              'app',
              'locale',
              'timestamp',
              'registertimestamp',
              'phoneno',
              'email',
              'status',
              'tags',
              'session',
              'profile_pic'
            ],
            ...filter
          }
        }

        api.post_all_users_calculate(data, function(error, response) {
          if (error) {
            reject(error)
          }

          var users = response.data
          // vm.total_user = response.count
          resolve({ users: users, isnext: response.isNext, count: response.count })
        })
      })
    },
    getMoreCustomers: function() {
      var vm = this
      vm.loading = true
      vm.getLoadUsers(vm.limit, vm.offset).then(
        function({ users, isnext, count }) {
          vm.offset += vm.limit
          vm.users = users
          vm.loading = false
        },
        function(error) {
          vm.loading = false
        }
      )
    },
    onFailLoad: function(index) {
      this.$set(this.users[index], 'profile_pic', '/static/img/assets/livechat/profile.png')
    },
    getFormatDate: function(date, format) {
      return dayjs(date).format(format)
    },
    onActiveStartDate: function(value) {
      var vm = this
      if (dayjs(this.filter.activeDate.end).isBefore(value)) {
        this.filter.activeDate.end = value
      }
      this.filter.activeDate.start = value
    },
    onActiveEndDate: function(value) {
      var vm = this
      if (dayjs(value).isBefore(this.filter.activeDate.start)) {
        this.filter.activeDate.start = value
      }
      this.filter.activeDate.end = value
    },
    onRegisterStartDate: function(value) {
      var vm = this
      if (dayjs(this.filter.registerDate.end).isBefore(value)) {
        this.filter.registerDate.end = value
      }
      this.filter.registerDate.start = value
    },
    onRegisterEndDate: function(value) {
      var vm = this
      if (dayjs(value).isBefore(this.filter.registerDate.start)) {
        this.filter.registerDate.start = value
      }
      this.filter.registerDate.end = value
    },
    getIntent: function() {
      let vm = this
      let auth = null
      let data = {
        pageid: vm.pageid
      }
      return new Promise((resolve, reject) => {
        api.getIntent(data, function(error, response) {
          if (error) {
            reject(error)
          }
          if (response.data) {
            var isFoundDefault = false
            vm.intents = response.data.map(val => {
              return {
                ...val,
                isShow: false
              }
            })
          }
          resolve()
        })
      })
    },

    async exportDataSummary(offset) {
      let vm = this
      var limit = 5000
      vm.loading = true

      var users = await vm.getLoadUsers(limit, offset)
      if (users.users && users.users.length > 0) {
      }
      var json = []
      if (typeof users.users !== 'undefined') {
        users.users.map(item => {
          var userid =
            vm.$store.getters.getPackage == 'premium'
              ? item.id
                ? item.id
                : '-'
              : this.$t('premium')
          var userid_split = null
          try {
            userid_split = item.app == 'line' ? userid.split('__')[0] : userid
          } catch (error) {
            userid_split = userid
          }
          var userData = {
            pageuid: userid_split,
            'Social Name':
              (item.first_name ? item.first_name : '') +
              ' ' +
              (item.last_name ? item.last_name : ''),
            'E-mail': item.email,
            Phone: item.phoneno
          }
          if (item.session) {
            Object.assign(userData, JSON.parse(item.session))
          }
          json.push(userData)
        })
        const dataWS = XLSX.utils.json_to_sheet(json)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, dataWS)
        XLSX.writeFile(wb, 'zwiz-data-summary.csv')
        vm.loading = false
      }
      vm.collectexportcustomersanalytic()
    },

    exportAlltype(type) {
      if (this.exportType === 'dataSummary') {
        this.exportDataSummaryAll()
      } else if (this.exportType === 'info') {
        this.exportCustomerAll()
      }
    },

    async exportDataSummaryAll() {
      let vm = this
      const limit = vm.exportAllLimit
      vm.loading = true
      vm.$store.dispatch('loading')
      vm.showExport = false

      var json = []
      try {
        for (let i = 0; i < vm.total_user; i += limit) {
          var users = await vm.getLoadUsers(limit, i)
          if (users.users && users.users.length > 0) {
            if (typeof users.users !== 'undefined' && users.users.length !== 0) {
              users.users.map(item => {
                var userid =
                  vm.$store.getters.getPackage == 'premium'
                    ? item.id
                      ? item.id
                      : '-'
                    : vm.$t('premium')
                var userid_split = null
                try {
                  userid_split = item.app == 'line' ? userid.split('__')[0] : userid
                } catch (error) {
                  userid_split = userid
                }
                var userData = {
                  pageuid: userid_split,
                  'Social Name':
                    (item.first_name ? item.first_name : '') +
                    ' ' +
                    (item.last_name ? item.last_name : ''),
                  'E-mail': item.email,
                  Phone: item.phoneno
                }
                if (item.session) {
                  Object.assign(userData, JSON.parse(item.session))
                }
                json.push(userData)
              })
              if (json.length >= vm.total_user) {
                const dataWS = XLSX.utils.json_to_sheet(json)
                const wb = XLSX.utils.book_new()
                XLSX.utils.book_append_sheet(wb, dataWS)
                XLSX.writeFile(wb, 'zwiz-data-summary.csv')
                vm.$store.dispatch('loading')
                vm.loading = false
              }
            }
          } else {
            console.log('error')
            vm.$store.dispatch('loading')
            vm.loading = false
            break
          }
        }
      } catch (error) {
        console.log(error)
        vm.$store.dispatch('loading')
        vm.loading = false
      }
      vm.collectexportcustomersanalytic()
    },

    exportCustomerAll: function() {
      let vm = this
      let csvContent = ''

      const limit = vm.exportAllLimit
      vm.loading = true
      vm.$store.dispatch('loading')
      vm.showExport = false
      var json = []
      for (let i = 0; i < this.total_user; i += limit) {
        vm.getLoadUsers(limit, i)
          .then(function({ users, isnext, count }) {
            if (users && users.length > 0) {
              $.each(users, function(index, val) {
                let locale = config.locale.find(function(locale) {
                  if (val.locale == locale.value) {
                    return true
                  }
                })
                var userid =
                  vm.$store.getters.getPackage == 'premium'
                    ? val.id
                      ? val.id
                      : '-'
                    : this.$t('premium')
                var userid_split = null
                try {
                  userid_split = val.app == 'line' ? userid.split('__')[0] : userid
                } catch (error) {
                  userid_split = userid
                }

                const getGenderAbb = gender => {
                  const genders = {
                    male: 'M',
                    female: 'F'
                  }
                  if (!genders.hasOwnProperty(gender)) return gender
                  return genders[gender]
                }

                var userData = {
                  pageuid: userid_split,
                  'Social Name':
                    (val.first_name ? val.first_name : '') +
                    ' ' +
                    (val.last_name ? val.last_name : ''),
                  Channel: val.app,
                  Gender: getGenderAbb(val.gender),
                  'Register Date': val.registertimestamp
                    ? dayjs(val.registertimestamp).format('DD/MM/YYYY-HH:mm')
                    : '-',
                  'Last Active Date': val.timestamp
                    ? dayjs(val.timestamp).format('DD/MM/YYYY-HH:mm')
                    : '-',
                  Email:
                    vm.$store.getters.getPackage == 'premium'
                      ? val.email
                        ? val.email
                        : ''
                      : this.$t('premium'),
                  Address: val.address,
                  'Phone No':
                    vm.$store.getters.getPackage == 'premium' ? val.phoneno : this.$t('premium'),
                  Status:
                    vm.$store.getters.getPackage == 'premium' ? val.status : this.$t('premium'),
                  Tag: vm.$store.getters.getPackage == 'premium' ? val.tags : this.$t('premium'),
                  Locale: locale ? locale : ''
                }
                json.push(userData)
              })
            } else {
              vm.loading = false
              vm.showExport = true
              return
            }
          })
          .then(() => {
            if (json.length >= this.total_user) {
              const dataWS = XLSX.utils.json_to_sheet(json)
              const csv = XLSX.utils.sheet_to_csv(dataWS)
              const wb = XLSX.utils.book_new()
              XLSX.utils.book_append_sheet(wb, dataWS)
              XLSX.writeFile(wb, 'zwiz-customer.csv')
              vm.$store.dispatch('loading')
              vm.loading = false
            }
          })
      }

      vm.collectexportcustomersanalytic()
    },

    exportCustomer: function(offset = 0) {
      let vm = this
      let csvContent = ''

      var limit = 5000
      vm.loading = true

      vm.getLoadUsers(limit, offset).then(
        function({ users, isnext, count }) {
          if (users && users.length > 0) {
            var json = []
            $.each(users, function(index, val) {
              let locale = config.locale.find(function(locale) {
                if (val.locale == locale.value) {
                  return true
                }
              })
              var userid =
                vm.$store.getters.getPackage == 'premium'
                  ? val.id
                    ? val.id
                    : '-'
                  : this.$t('premium')
              var userid_split = null
              try {
                userid_split = val.app == 'line' ? userid.split('__')[0] : userid
              } catch (error) {
                userid_split = userid
              }

              const eventData = vm.getEventData(val['event_data'])

              const getGenderAbb = gender => {
                const genders = {
                  male: 'M',
                  female: 'F'
                }
                if (!genders.hasOwnProperty(gender)) return gender
                return genders[gender]
              }

              var userData = {
                pageuid: userid_split,
                'Social Name':
                  (val.first_name ? val.first_name : '') +
                  ' ' +
                  (val.last_name ? val.last_name : ''),
                Channel: val.app,
                Gender: getGenderAbb(val.gender),
                'Register Date': val.registertimestamp
                  ? dayjs(val.registertimestamp).format('DD/MM/YYYY-HH:mm')
                  : '-',
                'Last Active Date': val.timestamp
                  ? dayjs(val.timestamp).format('DD/MM/YYYY-HH:mm')
                  : '-',
                Email:
                  vm.$store.getters.getPackage == 'premium'
                    ? val.email
                      ? val.email
                      : ''
                    : this.$t('premium'),
                Address: val.address,
                'Phone No':
                  vm.$store.getters.getPackage == 'premium' ? val.phoneno : this.$t('premium'),
                Status: vm.$store.getters.getPackage == 'premium' ? val.status : this.$t('premium'),
                Tag: vm.$store.getters.getPackage == 'premium' ? val.tags : this.$t('premium'),
                // 'Message Sent':
                //   vm.$store.getters.getPackage == 'premium' ? val.messagesent : this.$t('premium'),
                Locale: locale ? locale : '',
                // Intent:
                //     vm.$store.getters.getPackage == 'premium'
                //         ? val.intentlist
                //             ? val.intentlist.join(',')
                //             : ''
                //         : this.$t('premium'),
                // MessageSent: val.questionmessages ? val.questionmessages.replace(/;;/gim, ',') : '',
                // NumberMessageSent: val.usermessages,
                'Order Quantity': eventData['orderQuantity'],
                // 'Total Purchase Amount': eventData['totalPurchaseAmount'],
                'Customer Value': eventData['customerValue'],
                // 'Customer Value': eventData['totalPurchaseAmount'],
                'First Time Purchase': eventData['firstTimePurchase'],
                'Latest Purchase': eventData['latestPurchase']
              }

              json.push(userData)
            })

            // vm.exportCsv(csvContent, 'zwiz-customer-' + offset)
            const dataWS = XLSX.utils.json_to_sheet(json)
            const csv = XLSX.utils.sheet_to_csv(dataWS)
            const wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, dataWS)
            XLSX.writeFile(wb, 'zwiz-customer.csv')
            vm.loading = false
          } else {
            vm.loading = false
          }
        },
        function() {
          vm.loading = false
        }
      )
      vm.collectexportcustomersanalytic()
    },
    onExportCustomer(type) {
      this.exportType = type
      this.exportpagecount = Math.ceil(this.total_user / this.exportlimit)
      if (this.exportpagecount > 1) {
        this.showExport = true
      } else {
        if (this.exportType === 'dataSummary') {
          this.exportDataSummary(0)
        } else if (this.exportType === 'info') {
          this.exportCustomer(0)
        }
      }
    },
    async importCustomer() {
      const vm = this
      const result = await vm.$swal.fire({
        title: vm.$t('Do you want to import customer?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true
      })

      if (result.value) {
        vm.loading = true
        const response = await vm.post(
          `page/${vm.selectedBot.pageid}/insert-facebook-user-from-conversation`
        )
        if (response.success) {
          await vm.$store.dispatch('updateBotDetail')
          vm.loading = false
        } else {
          if (response.message) {
            await vm.$swal.fire({
              title: response.message,
              type: 'error',
              confirmButtonText: vm.$t('Confirm')
            })
            console.log(`insertUsersFromInbox -> ${response.message}`)
          } else {
            console.log(`insertUsersFromInbox -> error`)
          }
          vm.loading = false
        }
      }
    },
    getEventData(eventData) {
      const data = {
        orderQuantity: '-',
        totalPurchaseAmount: '-',
        firstTimePurchase: '-',
        latestPurchase: '-'
      }

      if (eventData && eventData['Purchase']) {
        const numberFormatter = Intl.NumberFormat()

        data['orderQuantity'] = Object.values(eventData['Purchase']['currencies']).reduce(
          (prev, curr) => prev + curr['quantity'],
          0
        )
        data['totalPurchaseAmount'] = Object.entries(eventData['Purchase']['currencies'])
          .filter(([key]) => this.$store.state.currencies.includes(key))
          .map(([key, value]) => {
            return `${numberFormatter.format(value.value)} ${key}`
          })
          .join(', ')

        data['customerValue'] = Object.entries(eventData['Purchase']['currencies'])
          .filter(([key]) => this.$store.state.currencies.includes(key))
          .map(([key, value]) => {
            return value.value
          })
          .join(', ')

        const firstTimePurchase = dayjs(eventData['Purchase']['created_at'])
        const latestPurchase = dayjs(eventData['Purchase']['last_updated_at'])

        if (firstTimePurchase.isValid()) {
          data['firstTimePurchase'] = firstTimePurchase.format('DD/MM/YYYY')
        }
        if (latestPurchase.isValid()) {
          data['latestPurchase'] = latestPurchase.format('DD/MM/YYYY')
        }
      }

      return data
    }
  },
  watch: {
    count: function(newVal, oldVal) {
      let vm = this
      if (newVal != oldVal) {
        vm.$emit('onUserLoaded', vm.count)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/view/analytics/User.js